// extracted by mini-css-extract-plugin
export default {"orderItemPriceSummaryWrapper":"OrderPriceDetails_orderItemPriceSummaryWrapper__VfUHD","annotation":"OrderPriceDetails_annotation__owoLh"};